import FilterControl from './FilterControl'
import LayerControl from './LayerControl'
import LayerToogle from './LayerToogle'
import MapLibreContainer from './MapContainer'
import Marker from './Marker'
import DeviceMarker from './Marker/DeviceMarker'
import ParkingLotMarker from './Marker/ParkingLotMarker'
import SessionMarker from './Marker/SessionMarker'
import MarkerCluster from './MarkerCluster'
import Popup from './Popup'
import Provider from './Provider'
import Tooltip from './Tooltip'
import ZoomControlFC from './ZoomControl'

type IMapLibreContainer = typeof MapLibreContainer

interface IInternalMapLibre extends IMapLibreContainer {
  Provide: typeof Provider
  LayerToogle: typeof LayerToogle
  ZoomControl: typeof ZoomControlFC
  Marker: typeof Marker
  Tooltip: typeof Tooltip
  Popup: typeof Popup
  MarkerCluster: typeof MarkerCluster
  DeviceMarker: typeof DeviceMarker
  SessionMarker: typeof SessionMarker
  FilterControl: typeof FilterControl
  LayerControl: typeof LayerControl
  ParkingLotMarker: typeof ParkingLotMarker
}

const MapLibre: IInternalMapLibre = MapLibreContainer as IInternalMapLibre
MapLibre.Provide = Provider
MapLibre.LayerToogle = LayerToogle
MapLibre.ZoomControl = ZoomControlFC
MapLibre.Marker = Marker
MapLibre.Tooltip = Tooltip
MapLibre.Popup = Popup
MapLibre.MarkerCluster = MarkerCluster
MapLibre.DeviceMarker = DeviceMarker
MapLibre.SessionMarker = SessionMarker
MapLibre.FilterControl = FilterControl
MapLibre.LayerControl = LayerControl
MapLibre.ParkingLotMarker = ParkingLotMarker

export default MapLibre
